'use client';

import { Button } from '@ui/components/button';
import { cn } from '@ui/lib/utils';
import { text } from '@modules/garden-planner/text';
import { useRef, useEffect, type ReactNode } from 'react';
import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faSeedling } from '@micks-yard/icons/solid/faSeedling';

interface PlantSelectionToolViewProps {
  isActive: boolean;
  onToggle: () => void;
  plantSelector: ReactNode;
}

export function PlantSelectionToolView({
  isActive,
  onToggle,
  plantSelector,
}: PlantSelectionToolViewProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive && ref.current) {
      ref.current.scrollIntoView({ block: 'nearest' });
    }
  }, [isActive]);

  return (
    <div ref={ref}>
      <div className="mb-3">
        <Button
          type="button"
          variant={isActive ? 'ghost' : 'outline'}
          className={cn(
            'w-full justify-start gap-2',
            isActive && 'bg-green-100 text-green-800 hover:bg-green-200 hover:text-green-800'
          )}
          onClick={onToggle}>
          <FaIcon icon={faSeedling} className="size-4" />
          {isActive ? text.exitPlantSelection : text.selectPlant}
        </Button>

        {isActive && plantSelector ? (
          <div className="bg-muted mt-2 rounded-r-md border-l-4 border-l-green-600 py-3 pr-3 pl-3">
            {plantSelector}
          </div>
        ) : null}
      </div>
    </div>
  );
}
